import type { ReactElement } from 'react'

import { DividendTable } from './Table'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
// import { AnotationList } from '@/components/layouts/Ir/AnotationList'
import { AHeading } from '@/components/layouts/Ir/Heading'
import { Paragraph } from '@/components/layouts/Ir/Paragraph'

import { useMpocketScript } from '@/hooks/useMpocketScript'
import type { StockDividendProps } from '@/types/stockDividend'

export const DividendPage = ({ items }: StockDividendProps) => {
  useMpocketScript('//irpocket.com/141A/irpocket/ir-stock-dividend.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/ir-stock-dividend.js')

  // const anotationlist: string[] = [
  //   '2022年6月期（実績）及び2023年6月期第2四半期累計期間（実績）の1株当たり当期（四半期）純利益は期中平均発行済株式数により算出しております。',
  //   '2023年6月期（予想）の1株当たり当期（四半期）純利益は公募予定株式数（23,800,000株）を含めた予定期中平均発行済株式数により算出し、オーバーアロットメントによる売出しに関連する第三者割当増資分（最大3,848,300株）は考慮しておりません。',
  //   '2023年1月31日付で普通株式1株につき200株の割合で株式分割を行っておりますが、2022年6月期の期首に当該株式分割が行われたと仮定し、1株当たり当期（四半期）純利益を算出しています。',
  // ]

  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Dividends and Shareholder Returns"
        subTitleText="配当・株主還元"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <section>
        <AHeading>利益配分に関する基本方針</AHeading>
        <Paragraph id="irp-highlight-table-dividend1" />
        <Spacer h={{ sp: 70, pc: 100 }} />
        <AHeading>1株当たり配当金の推移</AHeading>
        <DividendTable items={items} />
        <Spacer h={{ sp: 50, pc: 80 }} />
        {/* 1株当たり配当金の推移のグラフ非表示 */}
        {/* <div id="irp-chart-graph-dividendchart" /> */}
        <Spacer h={{ sp: 50, pc: 80 }} />
        {/* <AnotationList listItem={anotationlist} /> */}
        {/* <Spacer h={{ sp: 70, pc: 100 }} /> */}
        <AHeading>株主優待制度</AHeading>
        <Paragraph>株主優待は、実施しておりません。</Paragraph>
      </section>
    </Layout>
  )
}

DividendPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: '株式情報', path: '/ir/stock/' },
    { name: '配当・株主還元', path: '' },
  ]

  return (
    <>
      <Head
        title="配当・株主還元"
        description="トライアルホールディングスの利益配分に関する基本方針、配当金の情報について掲載しています。"
        ogp={{ url: 'ir/stock/dividend/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
